var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-border",staticStyle:{"height":"30vh","width":"100%","margin":"0 auto","text-align":"center","font-size":"16px"}},[_c('svg',{staticClass:"barchart-border",attrs:{"id":"barchart"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }